<span class="legend-item-color" [ngClass]="legendItem.color"></span>
<span>{{legendItem.text | translate}}</span>
